export default {
    isReusableBagFeatureEnabled(state) {
        return state.features?.reusable_bags;
    },
    isDisplayDietaryRequirementEnabled(state) {
        return state.features?.display_dietary_requirement;
    }
}